import React from "react";

import Accordion from "@/components/shared/Accordion";

import type { FaqProps } from "./faq.types";

import s from "./faq.module.scss";

const Faq = ({ faq }: FaqProps) => {
  return (
    <div className={s.wrapper}>
      <h2 className={`heading-sm ${s.title}`}>Perguntas frequentes</h2>
      {faq.slice(0, 10).map((item, index) => (
        <Accordion
          key={index}
          id={"panel-" + index}
          title={item.question}
          customStyles={{
            title: "subtitle-sm",
            root: s.custom_accordion_root,
            headline: s.custom_accordion_headline,
            body: s.custom_accordion_body,
            expanded: s.custom_accordion_expanded
          }}
        >
          <div
            className={`body-text-sm ${s.content}`}
            dangerouslySetInnerHTML={{ __html: item.answer }}
          />
        </Accordion>
      ))}
    </div>
  );
};

export default Faq;
